import * as contentRange from "content-range";

class SearchResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {
        return headers => {
            return $resource(configService.searchApi.url + "/v1/search/:type", {type: "@type"}, {
                query: {
                    method: "GET",
                    isArray: true,
                    headers: headers || {},
                    params: {
                        query: "@query",
                        filters: "@filters"
                    },
                    interceptor: {
                        response: res => {
                            const range = contentRange.parse(res.headers("Content-Range"));
                            const totalFound = range && range.length;
                            res.resource.metadata = { count: totalFound };
                            return res.resource;
                        }
                    }
                },
                count: {
                    method: "HEAD",
                    headers: headers || {},
                    params: {
                        query: "@query",
                        filters: "@filters"
                    },
                    transformResponse: (data, headersGetter) => {
                        const totalFound = headersGetter("content-range");
                        return {
                            count: parseInt(totalFound.split("/")[1], 10)
                        };
                    }
                }
            });
        };
    }

}

angular
    .module("thor.core.search.resource", [])
    .factory("searchResource", SearchResource);
